import React, { useState, useEffect } from 'react';
import { db, getFromDB } from "../../firebase";
import { doc, getDoc } from 'firebase/firestore';
import { useLocation, useNavigate } from 'react-router-dom'
import {Utils} from '../utils/Utils'
import {CountriesDB} from '../db/CountriesDB'

import { Link } from 'react-router-dom';

import "./Team.css"

function Team() {
    const location = useLocation()
    const idTeam = location.state.team
    const navigate = useNavigate();
    const [team, setTeam] = useState({})
    const [players, setPlayers] = useState([])
    const [coaches, setCoaches] = useState([])
    const [countries, setCountries] = useState([])

  useEffect(() => {
    const getTeamFromFirestore = async () => {
      try {
        const docRef = doc(db, 'teams', idTeam);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setTeam(docSnap.data())
          const playerList = docSnap.data().players
          playerList.sort((a,b)=> Number(a.position) - Number(b.position))
          setPlayers(playerList)
          return getDistinctCountries(playerList, false)
        }
      } catch (error) {
        console.error('Error al obtener los datos del equipo '+idTeam+': ', error);
      }
    };

    const getCoachesFromFirestore = async () => {
      try {
        const queryData = {table: 'coaches', conditions: {field: 'team', operator: '==', value: idTeam}}
        const dataResults = await getFromDB(queryData)
        if (dataResults !== undefined && dataResults.length > 0) {
          setCoaches(dataResults)
          return getDistinctCountries(dataResults, true)
        } else {
          return []
        }
      } catch (error) {
        console.error('Error al obtener los datos de los entrenadores del equipo '+idTeam+': ', error);
      }
    };

    const getDistinctCountries = (players, isCoach) => {
      const countriesDistinct = []
      players.forEach(player => {
        if (!countriesDistinct.includes(player.nationality)) {
          countriesDistinct.push(player.nationality)
        }
        if (!isCoach && player.nationality2 !== "" && !countriesDistinct.includes(player.nationality2)){
          countriesDistinct.push(player.nationality2)
        }
        if (!countriesDistinct.includes(player.countryLastTeam) && player.countryLastTeam !== ""){
          countriesDistinct.push(player.countryLastTeam)
        }
      })
      return countriesDistinct
    }

    getTeamFromFirestore().then(countriesPlayers => {
      getCoachesFromFirestore().then(countriesCoaches => {
        CountriesDB.getDistinct(countriesPlayers.concat(countriesCoaches)).then(countriesData => setCountries(countriesData))
      })  
    });
    
    
  }, [idTeam]);

  const showPlayers = () => {
    const playersRows = players.map((player, i) => showPlayerRow(player,i))
    return <table className="data-table player">
            <thead>
              <tr>
                <th rowSpan="2"></th>
                <th rowSpan="2"></th>
                <th rowSpan="2"></th>
                <th rowSpan="2"></th>
                <th rowSpan="2" className="centered">Altura</th>
                <th rowSpan="2" className="centered">Edad</th>
                <th rowSpan="2" className="centered">Licencia</th>
                <th rowSpan="2" className="centered">Nac.</th>
                <th colSpan="4">Equipo 25/26</th>
              </tr>
              <tr>
                <th>Part.</th>
                <th>Pts</th>
                <th>Rebs</th>
                <th>Asis</th>
              </tr>
            </thead>
            <tbody>
              {playersRows}
            </tbody>
          </table>
  }

  const showPlayerRow = (player, i) => {
    const classTr = i%2 === 0 ? "even" : ""
    return <><tr className={classTr} key={player.name}>
      <td rowSpan="2">{player.dorsal}</td>
      <td rowSpan="2" className="centered">{showPhoto(player.urlPhoto)}</td>
      <td rowSpan="2" className="position centered">{Utils.getPositionById(player.position).position.abr}</td>
      <td rowSpan="2" className="name"><Link to="/player" state={{ idPlayer: player.id, idTeam: idTeam }}>{player.name}</Link></td>
      <td rowSpan="2" className="centered">{player.height !== ""?Number(player.height).toFixed(2):""}</td>
      <td rowSpan="2" className="centered">{player.birthDate !== ""?Utils.getAge(player.birthDate):""}</td>
      <td rowSpan="2" className="centered">{player.licence}</td>
      <td rowSpan="2" className="centered">
        {Utils.showFlagCountry(countries,player.nationality)}
        {player.nationality2 !== ""?Utils.showFlagCountry(countries,player.nationality2):""}
      </td>
      <td colSpan="4" className="last-team">{showLastTeam(player)}</td>
    </tr>
    {showDataLastYear(player, classTr)}
    </>
  }

  const showLastTeam = player => {
    if (player.lastTeam.toLowerCase() !== "sin equipo") {
      return <>{player.lastTeam} ({player.categoryLastTeam} {Utils.showFlagCountry(countries,player.countryLastTeam)})</>
    } else {
      return <>{player.lastTeam}</>
    }
  }

  const showDataLastYear = (player, classTr) => {
    if (player.lastTeam.toLowerCase() !== "sin equipo") {
      return <tr className={classTr} key={`${player.name}2`}>  
        <td className="number-stats centered">{player.numMatches}</td>
        <td className="number-stats centered">{Utils.decimalDiv(player.points, player.numMatches, 1)}</td>
        <td className="number-stats centered">{Utils.decimalDiv(player.rebounds, player.numMatches, 1)}</td>
        <td className="number-stats centered">{Utils.decimalDiv(player.assists, player.numMatches, 1)}</td>
      </tr>
    } else {
      return <tr className={classTr} key={`${player.name}2`}>
        <td className="number-stats centered">-</td>
        <td className="number-stats centered">-</td>
        <td className="number-stats centered">-</td>
        <td className="number-stats centered">-</td>
      </tr>
    }
  }

  const showPhoto = url => {
    if (url !== '') {
      return <img className="photo" src={url} alt={url}></img>
    } else {
      return <></>
    }
  }

  const showCoaches = () => {
    if (coaches.length === 0) {
      return <></>
    }
    const coachesRows = coaches.map(coach => <tr key={coach.name}>
      <td>{showPhoto(coach.urlPhoto)}</td>
      <td className="name">{coach.name}</td>
      <td>{Utils.showFlagCountry(countries,coach.nationality)}</td>
      <td>{coach.birthDate !== ""?Utils.getAge(coach.birthDate):""}</td>
      <td>{coach.lastTeam} ({coach.categoryLastTeam} {Utils.showFlagCountry(countries,coach.countryLastTeam)})</td>
    </tr>)
    
    return <table className="data-table coach">
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th>Nac.</th>
                <th>Edad</th>
                <th>Equipo 25/26</th>
              </tr>
            </thead>
            <tbody>
              {coachesRows}
            </tbody>
          </table>
  }

  const goBack = () => {
    navigate('/')
  }

  const showAverageAge = () => {
    if (players.length === 0) return ""
    const totalAge = players.reduce((sum, player) => {
      return sum + Utils.getDecimalAge(player.birthDate)
    }, 0)
    const averageAge = totalAge / players.length;
    return averageAge.toFixed(2)+ " años";
  }

  const showAverageHeight = () => {
    if (players.length === 0) return ""
    const totalHeight = players.reduce((sum, player) => {
      return sum + Number(player.height)
    }, 0)
    const averageHeight = totalHeight / players.length;
    return averageHeight.toFixed(2)+ " m";
  }

  const showNumberLicences = () => {
    if (players.length === 0) return ""
    let response = ""
    const licences = Utils.licences
    licences.forEach(licence => {
      const playersLicence = players.filter(player => player.licence === licence.abr)
      if (playersLicence.length > 0) {
        response += playersLicence.length + " " + licence.abr + " - "
      }
    })
    return response.slice(0,-3)
  }


  return (
    <div className="team-container">
      <div className="header">
        <div className="header-left"><h2>{team.name}</h2></div>
        <div className="header-right"><button className="btn-go-back" onClick={goBack}>Volver</button></div>
      </div>
      <div className="container-team">
        <img className="logo-team-big" src={team.url_logo} alt={team.url_logo}></img>
        <h3>Entrenador</h3>
        {showCoaches()}
        <h3>Jugadores</h3>
        {showPlayers()}
        <div className="data-team">
          <p>Edad media: {showAverageAge()}</p>
          <p>Altura media: {showAverageHeight()}</p>
          <p>Licencias: {showNumberLicences()}</p>
        </div>
      </div>
    </div>
  )
}

export default Team